import React, { useCallback, useContext } from 'react';
import { observer } from 'mobx-react';
import Button from 'choerodon-ui/pro/lib/button/Button';
import { FuncType } from 'choerodon-ui/pro/lib/button/enum';
import Dropdown from 'choerodon-ui/pro/lib/dropdown/Dropdown';
import { Placements } from 'choerodon-ui/pro/lib/dropdown/enum';
import { $l } from 'choerodon-ui/pro/lib/locale-context';
import Tooltip from 'choerodon-ui/pro/lib/tooltip/Tooltip';
import Menu from '../../../menu';
import { Size } from '../../../_util/enum';
import TabsContext from '../../TabsContext';
import Icon from '../../../icon';
const { Item, SubMenu } = Menu;
const ItemSuffix = function ItemSuffix(props) {
    const { record, defaultKey, onDefaultKeyChange } = props;
    const { prefixCls, tabCountHideable, defaultChangeable, tabTitleEditable } = useContext(TabsContext);
    const itemKey = record.get('key');
    const showCount = record.get('showCount');
    const handleMenuClick = useCallback((arg) => {
        switch (arg.key) {
            case 'set_default':
                onDefaultKeyChange(itemKey);
                break;
            case 'rename':
                record.setState('editing', true);
                break;
            case 'show_count_yes':
                record.set('showCount', true);
                break;
            case 'show_count_no':
                record.set('showCount', false);
                break;
            default:
        }
    }, [record, onDefaultKeyChange, itemKey]);
    const renderCheckOption = (bool) => {
        if (showCount === bool) {
            return React.createElement(Icon, { type: "check", style: { float: 'right' } });
        }
    };
    const getTreeNodesMenus = () => {
        const menus = [];
        if (defaultChangeable && itemKey !== defaultKey) {
            menus.push(React.createElement(Item, { key: "set_default" },
                React.createElement("span", null, $l('Tabs', 'set_default')),
                React.createElement(Tooltip, { title: $l('Tabs', 'set_default_tip') },
                    React.createElement(Icon, { type: "help", className: `${prefixCls}-tip` }))));
        }
        if (tabTitleEditable) {
            menus.push(React.createElement(Item, { key: "rename" }, $l('Tabs', 'rename')));
        }
        if (tabCountHideable) {
            menus.push(React.createElement(SubMenu, { key: "show_count", title: $l('Tabs', 'show_count') },
                React.createElement(Item, { key: "show_count_yes" },
                    React.createElement("span", null, $l('Tabs', 'yes')),
                    renderCheckOption(true)),
                React.createElement(Item, { key: "show_count_no" },
                    React.createElement("span", null, $l('Tabs', 'no')),
                    renderCheckOption(false))));
        }
        if (menus.length) {
            return (React.createElement(Menu, { prefixCls: `${prefixCls}-dropdown-menu`, onClick: handleMenuClick, mode: "vertical" }, menus));
        }
    };
    const menu = getTreeNodesMenus();
    return menu ? (React.createElement(Dropdown, { overlay: menu, placement: Placements.bottomRight },
        React.createElement(Button, { funcType: FuncType.flat, size: Size.small, icon: "more_horiz", className: `${prefixCls}-customization-group-item-hover-button` }))) : null;
};
ItemSuffix.displayName = 'ItemSuffix';
export default observer(ItemSuffix);
